import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { Crosshair, Bot, Heart, Eye } from 'lucide-react';

export function Features() {
  const { t } = useTranslation();
  const items = [
    { Icon: Crosshair, title: t('features.f1_title'), desc: t('features.f1_desc') },
    { Icon: Bot,       title: t('features.f2_title'), desc: t('features.f2_desc') },
    { Icon: Heart,     title: t('features.f3_title'), desc: t('features.f3_desc') },
    { Icon: Eye,       title: t('features.f4_title'), desc: t('features.f4_desc') },
  ];

  return (
    <section className="section bg-kquest-900/40">
      <div className="container-narrow">
        <h2 className="font-pixel text-4xl sm:text-5xl font-bold text-center tracking-tight mb-16">
          {t('features.title')}
        </h2>

        <div className="grid md:grid-cols-2 gap-6">
          {items.map((it, i) => (
            <motion.div
              key={it.title}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="flex gap-5 p-6 bg-kquest-900/60 border-2 border-kquest-700 hover:border-kquest-500 transition-colors"
              style={{ boxShadow: 'inset 0 -3px 0 0 rgba(0,0,0,0.3)' }}
            >
              <div className="flex-shrink-0 w-12 h-12 bg-enchant-grad flex items-center justify-center border-2 border-kquest-700">
                <it.Icon className="w-6 h-6 text-kquest-950" strokeWidth={2.2} />
              </div>
              <div>
                <h3 className="font-pixel text-xl font-semibold mb-2">{it.title}</h3>
                <p className="text-kquest-300 leading-relaxed">{it.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
